import { render, staticRenderFns } from "./MaterialOrderTracking.vue?vue&type=template&id=35f5e827&scoped=true"
import script from "./MaterialOrderTracking.vue?vue&type=script&lang=js"
export * from "./MaterialOrderTracking.vue?vue&type=script&lang=js"
import style0 from "./MaterialOrderTracking.vue?vue&type=style&index=0&id=35f5e827&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f5e827",
  null
  
)

export default component.exports